export const QuestionTypesEnum = {
    YesNoAudioQuestion: 'Yes No Audio Question',
    YesNoTextQuestion: 'Yes No Text Question',
    TranscriptionQuestion: 'Transcription Question',
    AnnotationAudioMultichoiceQuestion: 'Annotation Audio Multichoice Question',
    AnnotationTextMultichoiceQuestion: 'Annotation Text Multichoice Question',
    AnnotationTextMultichoiceMultiscoreQuestion: 'Annotation Text Multichoice Multiscore Question',
    TranslationMultichoiceQuestion: 'Translation Multichoice Question',
    TranslationBasicQuestion: 'Translation Basic Question',
    VoiceCollectionTasks: 'Voice Collection Tasks',
    VoiceCollectionValidator: 'Voice Collection Validator',
    LSVocabulary: 'LS Vocabulary',
    LSReadingComprehension: 'LS Reading Comprehension',
    LSCriticalThinking: 'LS Critical Thinking',
    LSParallelReasoning: 'LS Parallel Reasoning',
    LSParagraphWriting: 'LS Paragraph Writing',
    LSImageDescribing: 'LS Image Describing',
    LSParagraphImprovement: 'LS Paragraph Improvement',
    LSParagraphSummary: 'LS Paragraph Summary',
};

export const question_types2 = [
    { code: 'Yes-no-audio', label: QuestionTypesEnum.YesNoAudioQuestion },
    { code: 'Yes-no-text', label: QuestionTypesEnum.YesNoTextQuestion },
    { code: 'Transcription', label: QuestionTypesEnum.TranscriptionQuestion },
    { code: 'Annotation-audio-multichoice', label: QuestionTypesEnum.AnnotationAudioMultichoiceQuestion },
    { code: 'Annotation-text-multichoice', label: QuestionTypesEnum.AnnotationTextMultichoiceQuestion },
    {
        code: 'Annotation-text-multichoice-multiscore',
        label: QuestionTypesEnum.AnnotationTextMultichoiceMultiscoreQuestion,
    },
    { code: 'Translation-multichoice', label: QuestionTypesEnum.TranslationMultichoiceQuestion },
    { code: 'Translation-basic', label: QuestionTypesEnum.TranslationBasicQuestion },
    { code: 'voice-collection-validator', label: QuestionTypesEnum.VoiceCollectionValidator },
    { code: 'vc-tasks', label: QuestionTypesEnum.VoiceCollectionTasks },
    { code: 'ls-vocabulary', label: QuestionTypesEnum.LSVocabulary },
    { code: 'ls-comprehension', label: QuestionTypesEnum.LSReadingComprehension },
    { code: 'ls-critical-thinking', label: QuestionTypesEnum.LSCriticalThinking },
    { code: 'ls-parallel-reasoning', label: QuestionTypesEnum.LSParallelReasoning },
    { code: 'ls-paragraph-writing', label: QuestionTypesEnum.LSParagraphWriting },
    { code: 'ls-image-describing', label: QuestionTypesEnum.LSImageDescribing },
    { code: 'ls-paragraph-improvement', label: QuestionTypesEnum.LSParagraphImprovement },
    { code: 'ls-paragraph-summary', label: QuestionTypesEnum.LSParagraphSummary },
];
